import { useNavigate } from "react-router-dom";
import { Mail, Phone, MapPin, Send } from "lucide-react";
import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";

export default function Contact() {
  const navigate = useNavigate();
  return (
    <Layout>
      <div className="bg-navy text-white py-14">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6">
          <h1 className="font-heading font-extrabold text-3xl sm:text-4xl">Contact Us</h1>
          <p className="text-white/60 mt-2">Talk to a freight expert or submit a shipment enquiry.</p>
        </div>
      </div>
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-14 grid lg:grid-cols-3 gap-6">
        {[
          { icon: Mail, t: "Email", d: "sales@vkforwarders.com" },
          { icon: Phone, t: "Phone", d: "+91 00000 00000" },
          { icon: MapPin, t: "Office", d: "Mumbai · Mundra · Chennai, India" },
        ].map((c) => (
          <div key={c.t} className="border border-border rounded-md p-6 bg-card">
            <div className="h-11 w-11 bg-navy rounded-sm flex items-center justify-center mb-4"><c.icon className="h-5 w-5 text-signal" /></div>
            <div className="font-heading font-bold text-navy">{c.t}</div>
            <div className="text-sm text-muted-foreground mt-1 font-mono-data">{c.d}</div>
          </div>
        ))}
      </div>
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 pb-20">
        <div className="border border-border rounded-md bg-navy text-white p-10 flex flex-col sm:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="font-heading font-extrabold text-2xl">Ready to plan a shipment?</h2>
            <p className="text-white/60 mt-1">Submit your requirement and our team confirms final rates.</p>
          </div>
          <Button className="bg-signal hover:bg-signal/90 text-white rounded-sm h-11 px-6" onClick={() => navigate("/enquiry")} data-testid="contact-plan-btn">
            <Send className="h-4 w-4 mr-2" /> Plan My Shipment
          </Button>
        </div>
      </div>
    </Layout>
  );
}
